import { render, staticRenderFns } from "./Contrats.vue?vue&type=template&id=937cc6bc&scoped=true&"
import script from "./Contrats.vue?vue&type=script&lang=js&"
export * from "./Contrats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937cc6bc",
  null
  
)

export default component.exports